/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from '../convo/defs.defs'

const $nsid = 'chat.bsky.group.createGroup'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  name: /*#__PURE__*/ l.string({
    maxLength: 500,
    minLength: 1,
    maxGraphemes: 50,
  }),
  members: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' }), {
    maxLength: 10000,
  }),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convo: /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
    (() => ConvoDefs.convoView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Creates a group convo, specifying the members to be added to it. Unlike getConvoForMembers, this isn't idempotent. It will create new groups even if the membership is identical to pre-existing groups. Will create 'request' membership for all members, except the owner who is 'accepted'. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'AccountSuspended',
  'BlockedActor',
  'BlockedSubject',
  'NewAccountCannotCreateGroup',
  'NotFollowedBySender',
  'RecipientNotFound',
  'UserForbidsGroups',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
